import * as React from "react";
import * as ReactDOM from "react-dom/client";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { ModalitySearch } from "../src/ModalitySearch/ModalitySearch";
import { GoogleScriptsProvider } from "../src/shared/GoogleScriptsContext";

Bugsnag.start({
  apiKey: window.AppConfig.BUGSNAG_FRONTEND_API_KEY || "invalid",
  plugins: [new BugsnagPluginReact()],
  releaseStage: window.AppConfig.RAILS_ENV,
  enabledReleaseStages: ["production", "staging"],
});

const googleScriptsLibraries = ["places" as const];

document.addEventListener("DOMContentLoaded", () => {
  let node = document.getElementById("modality_search");

  if (!node) {
    return;
  }

  const data = JSON.parse(node.getAttribute("data") || "[]");

  const area = data.area;
  const selectedScanType = data.scan_type;
  const availableBodyParts = data.available_body_parts ?? [];
  const selectedBodyParts = data.selected_body_parts ?? [];
  const isSearchBar = data.isSearchBar ?? false;
  const cta = data.cta ?? "Find a centre";

  const root = ReactDOM.createRoot(node);
  root.render(
    <GoogleScriptsProvider libraries={googleScriptsLibraries}>
      <ModalitySearch
        initialArea={area}
        selectedBodyParts={selectedBodyParts}
        scanType={selectedScanType}
        availableBodyParts={availableBodyParts}
        cta={cta}
        isSearchBar={isSearchBar}
      />
    </GoogleScriptsProvider>
  );
});
